import { Component, OnInit, Input } from '@angular/core';
import { Partner } from '../../models/partner';
import { PartnerStateEnum } from '../../services/partner-state.enum';
import { PartnerStateService } from '../../services/partner-state.service';
import { Observer, Observable } from 'rxjs';

@Component({
  selector: 'app-children',
  templateUrl: './children-management.component.html',
  styleUrls: ['./children-management.component.css']
})
export class ChildrenManagementComponent implements OnInit {

  private _activeComponentRef;

  constructor(
    protected partnerStateService: PartnerStateService
  ) {
  }

  ngOnInit() {
  }

  get partner(): Partner {
    return this.partnerStateService.loggedInPartner;
  }

  childListItemClicked($event) {
    this.partnerStateService.update(PartnerStateEnum.EditChild, $event);
    if (this._activeComponentRef) {
      this._activeComponentRef.partner = this.partnerStateService.selectedChild.clone;
    }
  }

  onActivate(componentRef) {
    this._activeComponentRef = componentRef;
  }
}
